export class Tags {
    tipo: string;
    label: string;
}
